// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"451":"a2ecb997","488":"f77101b5"}[chunkId] + ".chunk.js";
};